import { render, staticRenderFns } from "./plugin-sendback-sv.vue?vue&type=template&id=7e129c21&scoped=true&"
import script from "./plugin-sendback-sv.vue?vue&type=script&lang=js&"
export * from "./plugin-sendback-sv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e129c21",
  null
  
)

export default component.exports